module.exports = __webpack_public_path__ + "img/concert.33ec47f0.png";